import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { ToastProvider } from '@podus/ui';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { StateProvider } from '@/context/StateContext';
import { LanguageProvider } from '@/i18n/LanguageContext';
import { redirectToAuth } from '@/lib/sessionGuard';
import Home from './pages/Home';
import UserDashboardLayout from './components/dashboard/UserDashboardLayout';
import UserDashboard from './pages/Dashboard';
import UserSettings from './pages/Dashboard/Settings';
import CreateCase from './pages/Dashboard/CreateCase';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isLoggedIn } = useAuth();
    // No token / invalid token → kick over to auth's /sign-in?redirect=<this URL>.
    // After successful login, auth bounces the user back here with ?accessToken=…
    // which AuthContext picks up.
    useEffect(() => {
        if (!isLoggedIn) redirectToAuth();
    }, [isLoggedIn]);
    if (!isLoggedIn) return null;
    return <>{children}</>;
}

export function App() {
    return (
        <BrowserRouter>
            <ToastProvider>
                <LanguageProvider>
                    <AuthProvider>
                        <StateProvider>
                            <Routes>
                                {/* Landing / Login */}
                                <Route index element={<Home />} />

                                {/* Protected user dashboard */}
                                <Route
                                    path="dashboard"
                                    element={
                                        <ProtectedRoute>
                                            <UserDashboardLayout />
                                        </ProtectedRoute>
                                    }
                                >
                                    <Route index element={<UserDashboard />} />
                                    <Route path="create-case" element={<CreateCase />} />
                                    <Route path="settings" element={<UserSettings />} />
                                </Route>

                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </StateProvider>
                    </AuthProvider>
                </LanguageProvider>
            </ToastProvider>
        </BrowserRouter>
    );
}
